import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
  setDoc,
  getDoc,
  onSnapshot,
  deleteDoc,
  addDoc,
} from "firebase/firestore";
import { db } from "../api/firebase";
import { auth } from "../api/firebase";
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  ButtonGroup,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"; // 上部でimport
import {
  runTransaction,
  deleteField,
  serverTimestamp,
} from "firebase/firestore";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";
import MailPreviewBox from "./MailPreviewBox";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Chip } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import { styled } from "@mui/material/styles";
import SendIcon from "@mui/icons-material/Send"; // ★追加

import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"; // トロフィーっぽいアイコン
import Alert from "@mui/material/Alert";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";

// 回転アニメーション付きのボタンを

// 🐾 アバター画像
const animalAvatars = [
  "https://cdn-icons-png.flaticon.com/512/616/616408.png",
  "https://cdn-icons-png.flaticon.com/512/616/616430.png",
  "https://cdn-icons-png.flaticon.com/512/616/616490.png",
  "https://cdn-icons-png.flaticon.com/512/616/616408.png",
  "https://cdn-icons-png.flaticon.com/512/616/616408.png",
  "https://cdn-icons-png.flaticon.com/512/616/616408.png",
];

// 🎨 パステル背景色
const pastelColors = [
  "#FFF5F7",
  "#F0FDF4",
  "#F0F9FF",
  "#FFFDF0",
  "#FDF4FF",
  "#F3F8FF",
];

// 🔧 色を少し暗くする関数
const darkenColor = (hex, amount = 0.2) => {
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) - 255 * amount;
  let g = ((num >> 8) & 0x00ff) - 255 * amount;
  let b = (num & 0x0000ff) - 255 * amount;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
};

const stringToNumberHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

const getAvatarByKey = (key) => {
  const index = stringToNumberHash(key) % animalAvatars.length;
  return animalAvatars[index];
};

const getColorByKey = (key) => {
  const index = stringToNumberHash(key) % pastelColors.length;
  return pastelColors[index];
};

const ReviewGroupMemberList = () => {
  const { id } = useParams();
  const [members, setMembers] = useState([]);
  const [myPrefecture, setMyPrefecture] = useState("");
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [currentTargetId, setCurrentTargetId] = useState("");
  const [commentInput, setCommentInput] = useState("");
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const currentUser = auth.currentUser;

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmationChecked, setConfirmationChecked] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [contactTarget, setContactTarget] = useState(null); // memberオブジェクトを入れる
  const [filterType, setFilterType] = useState("all"); // "all", "commented", "mailed"

  // ステート追加
  const [mailConfirmOpen, setMailConfirmOpen] = useState(false);
  const [mailConfirmChecked, setMailConfirmChecked] = useState(false);

  // ★ 応募ダイアログ用
  const [applyOpen, setApplyOpen] = useState(false);
  const [applyTarget, setApplyTarget] = useState(null);
  const [applyComment, setApplyComment] = useState(""); // コメントを書くとき意識したこと
  const [applyApproach, setApplyApproach] = useState(""); // ブース対話で大切にしたいこと

  const [confirmEditOpen, setConfirmEditOpen] = useState(false);

  // ★ 締切（UTC で管理）
  const DEADLINE = new Date("2025-05-10T23:59:00+09:00");
  const [beforeDeadline, setBeforeDeadline] = useState(
    () => new Date() < DEADLINE
  );

  // ✅ 自分の都道府県を取得
  useEffect(() => {
    const fetchUserPrefecture = async () => {
      if (!currentUser) return;
      const userDoc = await getDoc(doc(db, "users", currentUser.uid));
      if (userDoc.exists()) {
        setMyPrefecture(userDoc.data().prefecture || "");
      }
    };
    fetchUserPrefecture();
  }, [currentUser]);

  // ✅ DDPデータ取得
  useEffect(() => {
    if (!id) return;

    const q = query(
      collection(db, "ReiNoInori"),
      where("reviewGroupId", "==", id)
    );

    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      const docs = querySnapshot.docs.map((doc) => {
        const key = doc.data().mail || doc.id;
        return {
          id: doc.id,
          avatar: getAvatarByKey(key),
          bgColor: getColorByKey(key),
          ...doc.data(),
        };
      });

      const uniqueCommentedByUids = [
        ...new Set(
          docs.filter((doc) => doc.commentedBy).map((doc) => doc.commentedBy)
        ),
      ];

      const uidToNameMap = {};
      for (const uid of uniqueCommentedByUids) {
        const userSnap = await getDoc(doc(db, "users", uid));
        if (userSnap.exists()) {
          uidToNameMap[uid] = userSnap.data().name || "匿名さん";
        }
      }

      const membersWithNames = docs.map((doc) => ({
        ...doc,
        commentUserName: uidToNameMap[doc.commentedBy] || null,
      }));

      setMembers(membersWithNames);
      setLoading(false);
    });

    return () => unsubscribe(); // クリーンアップ
  }, [id]);

  useEffect(() => {
    // 30 秒ごとに締切チェック
    const timerId = setInterval(() => {
      const stillBefore = new Date() < DEADLINE;
      setBeforeDeadline(stillBefore);

      // いったん false になったらタイマーを止める
      if (!stillBefore) clearInterval(timerId);
    }, 30_000); // 30,000 ms = 30 秒

    return () => clearInterval(timerId); // アンマウント時にクリーン
  }, []);

  // --- effect ---
  // useEffect(() => {
  //   if (!applyOpen || !applyTarget) return;

  //   (async () => {
  //     try {
  //       // ① ReiNoInori の存在確認
  //       const reiDoc = await getDoc(
  //         doc(db, "ReiNoInori", applyTarget.id)
  //       );
  //       console.log(
  //         `[応募フォーム] ReiNoInori/${applyTarget.id} exists?`,
  //         reiDoc.exists()
  //       );

  //       // ② 既存応募確認
  //       const q = query(
  //         collection(db, "KannabeDDP"),
  //         where("ddpId", "==", applyTarget.id),
  //         where("applicantUid", "==", currentUser.uid)
  //       );
  //       const snap = await getDocs(q);
  //       console.log(
  //         `[応募フォーム] ${
  //           snap.empty ? "初回応募" : "応募済み（編集モード）"
  //         }`
  //       );
  //     } catch (err) {
  //       console.error("応募フォーム準備エラー:", err.code, err.message, err);
  //     }
  //   })();
  // }, [applyOpen, applyTarget, currentUser]);

  const reserveCommentSlot = async (ddpId, userId) => {
    const ref = doc(db, "ReiNoInori", ddpId);
    try {
      await runTransaction(db, async (transaction) => {
        const snapshot = await transaction.get(ref);
        const data = snapshot.data();

        if (
          data.commentedBy ||
          (data.commentingBy && data.commentingBy !== userId)
        ) {
          throw new Error("すでにコメント中または完了しています");
        }

        transaction.update(ref, {
          commentingBy: userId,
        });
      });
      return true;
    } catch (err) {
      console.warn("予約失敗:", err.message);
      return false;
    }
  };

  const handleOpenDialog = async (ddpId) => {
    const success = await reserveCommentSlot(ddpId, currentUser.uid);
    if (success) {
      setCurrentTargetId(ddpId);
      setCommentInput("");
      setOpen(true);
    } else {
      alert("現在、他の方がコメント中です。しばらくしてからお試しください。");
    }
  };

  const handleCloseDialog = async () => {
    setOpen(false);
    if (currentTargetId) {
      await updateDoc(doc(db, "ReiNoInori", currentTargetId), {
        commentingBy: deleteField(),
      });
    }
    setCurrentTargetId("");
  };

  const handleSubmitComment = async () => {
    try {
      const targetDocRef = doc(db, "ReiNoInori", currentTargetId);

      // 既にコメントがあるか読んで判定（ローカル state でも可）
      const snap = await getDoc(targetDocRef);
      const isEditing = !!snap.data()?.comment;

      await updateDoc(targetDocRef, {
        comment: commentInput.trim(),
        commentedBy: currentUser.uid,
        ...(isEditing && { editedAt: serverTimestamp() }),
      });

      setMembers((prev) =>
        prev.map((m) =>
          m.id === currentTargetId
            ? {
                ...m,
                comment: commentInput.trim(),
                commentedBy: currentUser.uid,
              }
            : m
        )
      );
      handleCloseDialog();
    } catch (err) {
      console.error("コメント送信エラー:", err);
    }
  };

  const appBaseUrl = "https://mastermindmembers.net"; // ← 自分のサイトURLに変更
  const yourName = currentUser?.displayName || "匿名"; // 送信者の名前

  // 📩 5段階リンク（各スコアに合わせたテキスト）
  const reactionLabels = [
    "大変参考になった",
    "より詳しく聞きたい",
    "質問をしてみたい",
    "気づきがあった",
    "ありがとう",
  ];

  const ratingLinks = [1, 2, 3, 4, 5]
    .map((score) => {
      const url = `${appBaseUrl}/rate?ddpId=${contactTarget?.id}&score=${score}`;
      return `・${reactionLabels[score - 1]}\n${url}`;
    })
    .join("\n");

  const mailBody = [
    `${contactTarget?.name}さま`,
    ``,
    `こんにちは。`,
    `マスターマインドメンバーズの${yourName}です。`,
    ``,
    `このたびは「AIレイの祈り」にご登録いただき、誠にありがとうございます。`,
    ``,
    `お預かりしたあなたの祈り、`,
    `「${contactTarget?.ddp}」 に対して、`,
    `心を込めて、以下のようなアドバイスをご用意いたしました。`,
    ``,
    `――――――――――――――――`,
    `添削内容`,
    `"${contactTarget?.comment}"`,
    `――――――――――――――――`,
    ``,
    `もし何かのヒントやきっかけになりましたら幸いです。`,
    `よろしければ、こちらのアドバイスについて、あなたのリアクションをお聞かせいただけますでしょうか？`,
    `ご感想をいただけると、今後の活動の励みにもなります✨`,
    ``,
    `▼以下のリンクからお選びください`,
    ratingLinks,
    ``,
    `今後の歩みが、ますますあなたらしい輝きに満ちたものとなりますように。`,
    `引き続き、どうぞよろしくお願いいたします。`,
    ``,
    `心をこめて`,
    `マスターマインドメンバーズ　${yourName}より`,
  ].join("\n");

  const mailtoLink = `mailto:${
    contactTarget?.mail
  }?subject=${encodeURIComponent(
    "あなたの祈りへのささやかなアドバイスをお届けします"
  )}&body=${encodeURIComponent(mailBody)}`;

  const copyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
      alert("メール本文をコピーしました！✂️");
    } catch (err) {
      alert("コピーに失敗しました。手動でコピーしてください🙏");
    }
    document.body.removeChild(textArea);
  };

  const maskName = (name) => {
    if (!name) return "";
    const firstChar = name.charAt(0);
    const masked = "●".repeat(name.length - 1);
    return `${firstChar}${masked}`;
  };

  const filteredMembers = members.filter((member) => {
    if (filterType === "commented") {
      return member.commentedBy === currentUser?.uid;
    } else if (filterType === "mailed") {
      return member.mailedBy === currentUser?.uid;
    } else {
      return true; // all
    }
  });

  //   console.log(mailBody);

  // 回転アニメーション付きのボタンを styled で用意
  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }));
  const [expandedId, setExpandedId] = useState(null);

  const handleExpandClick = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const normalizePrefecture = (pref) => {
    if (!pref) return "";

    // 全角カッコ → 半角に変換
    let normalized = pref
      .replace(/[（）]/g, (m) => (m === "（" ? "(" : ")"))
      .replace(/\s+/g, "") // 空白削除
      .trim();

    // 表記ゆれを統一
    const mapping = {
      "海外(アメリカ)": "海外(アメリカ)",
      "海外(その他)": "海外(その他)",
      その他海外: "海外(その他)",
      アメリカ: "海外(アメリカ)", // 追加したいものがあればここに
    };

    return mapping[normalized] || normalized;
  };

  const handleApply = async (member) => {
    // TODO: 応募処理を実装（例：別ダイアログ表示、Firestore 更新など）
    console.log(`${member.name} さんに応募します`, member);
    alert(`${maskName(member.name)} さんへ応募しました！🚀`);
  };

  // 編集の場合は既存 doc の ref を探して updateDoc
  const handleSave = async () => {
    const q = query(
      collection(db, "KannabeDDP"),
      where("ddpId", "==", applyTarget.id),
      where("applicantUid", "==", currentUser.uid)
    );
    const snap = await getDocs(q);
    if (!snap.empty) {
      await updateDoc(snap.docs[0].ref, {
        commentPoint: applyComment.trim(),
        approach: applyApproach.trim(),
        updatedAt: serverTimestamp(),
      });
    }
    // state 更新して閉じる…
  };

  const handleCancel = async (member) => {
    if (!beforeDeadline) return;

    // ① KannabeDDP を削除
    const q = query(
      collection(db, "KannabeDDP"),
      where("ddpId", "==", member.id),
      where("applicantUid", "==", currentUser.uid)
    );
    const snap = await getDocs(q);
    if (!snap.empty) {
      await deleteDoc(snap.docs[0].ref);
    }

    // ② ReiNoInori 応募フラグをクリア
    await updateDoc(doc(db, "ReiNoInori", member.id), {
      applicant: deleteField(),
      applied: deleteField(),
    });

    // ③ ローカル state 反映
    setMembers((prev) =>
      prev.map((m) =>
        m.id === member.id ? { ...m, applied: false, applicant: null } : m
      )
    );
    alert("応募を取消しました。別の DDP に応募し直せます。");
  };

  // ★ どの応募カードも applied=true & applicant===自分 なら true
  const userAlreadyApplied = useMemo(
    () => members.some((m) => m.applicant === currentUser?.uid),
    [members, currentUser]
  );

  const handleEdit = async (member) => {
    setApplyTarget(member); // ダイアログ用に保持
    setApplyOpen(true); // 先に開いておくと UX が速い

    // ① 応募済ドキュメントを探す
    const q = query(
      collection(db, "KannabeDDP"),
      where("ddpId", "==", member.id),
      where("applicantUid", "==", currentUser.uid)
    );
    const snap = await getDocs(q);

    // ② あればその値、無ければ member から（編集後すぐ再編集する場合）
    if (!snap.empty) {
      const data = snap.docs[0].data();
      setApplyComment(data.commentPoint || "");
      setApplyApproach(data.approach || "");
    } else {
      setApplyComment(member.commentPoint || "");
      setApplyApproach(member.approach || "");
    }
  };

  /** undefined を Firestore が許容する null に変換するユーティリティ */
  const toNull = (v) => (v === undefined ? null : v);

  // ★ 応募ダイアログの OK ボタンは onClick={handleSubmit} だけで OK
  const handleSubmit = async () => {
    if (!currentUser || !applyTarget) return;

    try {
      // ① 既存応募があるかチェック
      const q = query(
        collection(db, "KannabeDDP"),
        where("ddpId", "==", applyTarget.id),
        where("applicantUid", "==", currentUser.uid)
      );
      const snap = await getDocs(q);

      /* === 初回応募 ============================= */
      if (snap.empty) {
        const docData = {
          ddpId: applyTarget.id,
          applicantUid: currentUser.uid,
          ddpText: toNull(applyTarget.ddp),
          memberMail: toNull(applyTarget.mail),
          memberName: toNull(applyTarget.name),
          memberPref: toNull(applyTarget.prefecture),
          commentPoint: applyComment.trim(),
          approach: applyApproach.trim(),
          createdAt: serverTimestamp(),
        };
        console.log("[応募フォーム] addDoc payload:", docData); // デバッグ用
        await addDoc(collection(db, "KannabeDDP"), docData);

        // ReiNoInori ドキュメントが未作成でも OK になるよう setDoc + merge
        await setDoc(
          doc(db, "ReiNoInori", applyTarget.id),
          { applicant: currentUser.uid, applied: true },
          { merge: true }
        );

        alert("応募を送信しました！🚀");
      } else {
        /* === 編集：まず確認ダイアログ ================ */
        if (
          !window.confirm(
            "すでに応募済みです。内容を更新してもよろしいですか？"
          )
        )
          return; // キャンセルなら何もしないで閉じる

        await updateDoc(snap.docs[0].ref, {
          commentPoint: applyComment.trim(),
          approach: applyApproach.trim(),
          updatedAt: serverTimestamp(),
        });

        alert("応募内容を更新しました！✏️");
      }

      /* --- ローカル state を反映 --- */
      setMembers((prev) =>
        prev.map((m) =>
          m.id === applyTarget.id
            ? {
                ...m,
                applicant: currentUser.uid,
                applied: true,
                commentPoint: applyComment.trim(),
                approach: applyApproach.trim(),
              }
            : m
        )
      );
    } catch (err) {
      console.error("応募送信エラー:", err?.code, err?.message, err);
      alert(
        `応募に失敗しました: ${
          err?.message ?? "ネットワークを確認して再度お試しください。"
        }`
      );
    } finally {
      // 後片付け
      setApplyOpen(false);
      setApplyComment("");
      setApplyApproach("");
      setApplyTarget(null);
    }
  };
  // 既存の useState 群の下あたりに追加
  const handleDialogClose = () => {
    setApplyOpen(false);
    setApplyComment("");
    setApplyApproach("");
    setApplyTarget(null);
  };

  if (loading) return <div>読み込み中...</div>;

  return (
    <div style={{ padding: "2rem" }}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography>
          ゆめナビでの添削活動は、
          <strong>2025年6月5日（水）&nbsp;23:59</strong>{" "}
          をもって終了となります。
        </Typography>
        <Typography>
          この時間を過ぎますと、システム上の操作ができなくなりますので、
          添削活動は、期限内にコメント及びメール送信をお願いいたします。
        </Typography>
      </Alert>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "2rem",
        }}
      >
        <ButtonGroup variant="outlined">
          <Button
            variant={filterType === "all" ? "contained" : "outlined"}
            onClick={() => setFilterType("all")}
          >
            すべて
          </Button>
          <Button
            variant={filterType === "commented" ? "contained" : "outlined"}
            onClick={() => setFilterType("commented")}
          >
            コメント済
          </Button>
          <Button
            variant={filterType === "mailed" ? "contained" : "outlined"}
            onClick={() => setFilterType("mailed")}
          >
            メール連絡済
          </Button>
        </ButtonGroup>
      </div>

      <Grid container spacing={3}>
        {filteredMembers.map((member) => {
          const isSamePrefecture =
            normalizePrefecture(member.prefecture) ===
            normalizePrefecture(myPrefecture);

          const isAlreadyCommented = member.commentedBy === currentUser?.uid;
          const isCommentingByMe = member.commentingBy === currentUser?.uid;
          const isSomeoneCommenting = member.commentingBy && !isCommentingByMe;

          const canComment =
            isSamePrefecture &&
            !isAlreadyCommented &&
            (!member.commentingBy || isCommentingByMe);

          //   // 👇 ここにログを入れて確認
          //   console.log("🪵 member.name:", member.name);
          //   console.log("🧪 member.prefecture:", member.prefecture);
          //   console.log("🧪 myPrefecture:", myPrefecture);
          //   console.log("🧪 isSamePrefecture:", isSamePrefecture);
          //   console.log("🧪 isAlreadyCommented:", isAlreadyCommented);
          //   console.log("🧪 isSomeoneCommenting:", isSomeoneCommenting);
          //   console.log("✅ canComment:", canComment);

          const cardBgColor = canComment
            ? member.bgColor
            : darkenColor(member.bgColor, 0.2);
          return (
            <Grid item xs={12} sm={6} md={4} key={member.id}>
              <Card
                sx={{
                  position: "relative",
                  borderRadius: 5,
                  boxShadow:
                    member.mailedBy === currentUser?.uid
                      ? "0 0 0 3px #f48fb1"
                      : 2,
                  backgroundColor: cardBgColor,
                  paddingY: 1,
                  paddingX: 2,
                  opacity: canComment ? 1 : 0.85,
                }}
              >
                <CardHeader
                  avatar={
                    <Avatar
                      src={member.avatar}
                      sx={{ width: 56, height: 56 }}
                    />
                  }
                  title={
                    <>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ fontFamily: '"Rounded Mplus 1c", sans-serif' }}
                      >
                        {maskName(member.name)}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontFamily: '"Rounded Mplus 1c", sans-serif' }}
                      >
                        @{member.prefecture}
                      </Typography>
                    </>
                  }
                  action={
                    <ExpandMore
                      expand={expandedId === member.id}
                      onClick={() => handleExpandClick(member.id)}
                      aria-expanded={expandedId === member.id}
                      aria-label="コメントを表示"
                    >
                      <ExpandMoreIcon />
                    </ExpandMore>
                  }
                />

                <CardContent>
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: '"Rounded Mplus 1c", sans-serif',
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {member.ddp}
                  </Typography>

                  <Collapse
                    in={expandedId === member.id}
                    timeout="auto"
                    unmountOnExit
                  >
                    <div style={{ marginTop: "1rem" }}>
                      {member.comment ? (
                        <>
                          <Typography
                            variant="body2"
                            sx={{ fontStyle: "italic" }}
                          >
                            🌟 添削済 by {member.commentUserName || "？"}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              backgroundColor: "#f1f8e9",
                              padding: "0.5rem 1rem",
                              borderLeft: "4px solid #4caf50",
                              borderRadius: 2,
                              whiteSpace: "pre-wrap",
                              mt: 1,
                            }}
                          >
                            {member.comment}
                          </Typography>
                          {/* 添削連絡 */}
                          {/* {member.commentedBy === currentUser?.uid && (
                            <Button
                              variant="outlined" // → 色を付けて目立たせる
                              color="primary"
                              size="small"
                              startIcon={<SendIcon />} // ★紙飛行機アイコン
                              sx={{ mt: 1 }}
                              onClick={() => {
                                setContactTarget(member);
                                setContactOpen(true);
                              }}
                            >
                              添削連絡
                            </Button>
                          )} */}
                        </>
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: "italic" }}
                        >
                          添削コメントはまだありません
                        </Typography>
                      )}
                    </div>
                  </Collapse>

                      {/* コメント編集 */}
                  {/* {member.commentedBy === currentUser?.uid && (
                    <Button
                      size="small"
                      variant="outlined" // ★アウトラインで統一感
                      startIcon={<EditIcon />} // ✏️ 編集アイコン
                      sx={{
                        mt: 1,
                        px: 2.5, // 横パディングで押しやすく
                        borderWidth: 2, // 枠線を太めにして目立たせる
                        fontWeight: 600, // 文字を太字
                        textTransform: "none", // 小文字保持
                        color: "primary.main", // ブランド色
                        borderColor: "primary.main",
                        "&:hover": {
                          bgcolor: "primary.light",
                          borderColor: "primary.main",
                        },
                      }}
                      onClick={() => {
                        // 既存コメントをセットしてダイアログを再利用
                        setCurrentTargetId(member.id);
                        setCommentInput(member.comment || "");
                        setOpen(true); // コメント入力ダイアログを再表示
                      }}
                    >
                      コメントを編集
                    </Button>
                  )} */}
                    {/* コメント編集 */}
                  {/* {isSomeoneCommenting && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 2, fontStyle: "italic" }}
                    >
                      現在、他の方がコメント入力中です
                    </Typography>
                  )} */}

                  {/* コメントする */}
                  {/* {canComment && !member.comment && (
                    <Button
                      variant="outlined"
                      sx={{ marginTop: 2 }}
                      onClick={() => handleOpenDialog(member.id)}
                    >
                      コメントする
                    </Button>
                  )} */}

                  {/* 応募する */}
                  {/* ★ 応募ボタン ─ mailedBy が自分の UID と一致していたら表示 */}
                  {/* {member.mailedBy === currentUser?.uid && !member.applied && (
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ mt: 2 }}
                      disabled={!beforeDeadline || userAlreadyApplied}
                      onClick={() => {
                        if (!beforeDeadline) return; // 念のため
                        setApplyTarget(member);
                        setApplyOpen(true);
                      }}
                    >
                      応募する
                    </Button>
                  )} */}

                  {/* 応募編集 */}
                  {member.applicant === currentUser?.uid && (
                    <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                      {/* 応募編集ボタン */}
                      {/* <Button
                        size="small"
                        variant="outlined"
                        startIcon={<EditIcon />}
                        disabled={!beforeDeadline} // ← () を外した
                        onClick={() => handleEdit(member)}
                      >
                        応募編集
                      </Button> */}

                      {/* 応募取消ボタン */}
                      {/* <Button
                        size="small"
                        color="error"
                        variant="contained"
                        disabled={!beforeDeadline} // ← 同じく
                        onClick={() => handleCancel(member)}
                      >
                        神鍋DDPブース応募取消
                      </Button> */}
                    </Box>
                  )}

                  {/* メール済 */}
                  {member.mailedBy === currentUser?.uid && (
                    <div
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        backgroundColor: "#f48fb1",
                        color: "white",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                      }}
                    >
                      <MailOutlineIcon
                        fontSize="small"
                        sx={{ color: "#ffffff" }}
                      />
                      メール済
                    </div>
                  )}

                  {/* ★ 神鍋DDP 応募済バッジ */}
                  {member.applicant === currentUser?.uid && (
                    <div
                      style={{
                        position: "absolute",
                        top: 8,
                        /* メール済バッジもある場合は 1 個ぶん左へずらす */
                        right: member.mailedBy === currentUser?.uid ? 88 : 8,
                        backgroundColor: "#ff9800", // オレンジ
                        color: "white",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <EmojiEventsIcon
                        fontSize="small"
                        sx={{ color: "#ffffff" }}
                      />
                      神鍋DDP応募済
                    </div>
                  )}

                  {/* ⭐ rating があれば評価ラベルを表示 */}
                  {typeof member.rating === "number" && (
                    <Box sx={{ mt: 2 }}>
                      <Chip
                        label={
                          {
                            1: "大変参考になった",
                            2: "より詳しく聞きたい",
                            3: "質問をしてみたい",
                            4: "気づきがあった",
                            5: "ありがとう",
                          }[member.rating]
                        }
                        color={
                          {
                            1: "primary",
                            2: "secondary",
                            3: "warning",
                            4: "info",
                            5: "success",
                          }[member.rating]
                        }
                        icon={<StarIcon />}
                        sx={{ fontWeight: "bold" }}
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* MUIのコメント用ダイアログ */}
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            width: "90vw",
            maxWidth: { xs: "100%", sm: "600px", md: "800px" },
            padding: 2,
          },
        }}
      >
        {/* <DialogTitle>応援コメントを書く</DialogTitle> */}
        {/* 🧠 ヒントボタン（右上） */}
        <Button
          onClick={() => setOpenInfoDialog(true)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            minWidth: 0,
            padding: 1,
            borderRadius: "50%",
            backgroundColor: "white",
            boxShadow: 1,
          }}
        >
          <HelpOutlineIcon color="primary" />
        </Button>

        <DialogContent>
          {(() => {
            const selectedMember = members.find(
              (m) => m.id === currentTargetId
            );
            if (!selectedMember) return null;

            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <Avatar
                  src={selectedMember.avatar}
                  alt="avatar"
                  sx={{ width: 64, height: 64, marginRight: 2 }}
                />
                <div>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    {maskName(selectedMember.name)} さんのDDP
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontStyle: "italic",
                      backgroundColor: "#f9f9f9",
                      borderRadius: 2,
                      padding: "0.5rem 1rem",
                      marginTop: "4px",
                    }}
                  >
                    “{selectedMember.ddp}”
                  </Typography>
                </div>
              </div>
            );
          })()}

          <TextField
            fullWidth
            multiline
            minRows={4}
            label="夢叶えアドバイス"
            value={commentInput}
            onChange={(e) => setCommentInput(e.target.value)}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog}>キャンセル</Button>
          <Button
            onClick={() => setConfirmOpen(true)}
            disabled={!commentInput.trim()}
            variant="contained"
          >
            送信
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>最終確認</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            このコメントを本当に送信してもよいですか？
          </Typography>

          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              id="confirmationCheck"
              checked={confirmationChecked}
              onChange={(e) => setConfirmationChecked(e.target.checked)}
              style={{ marginRight: 8 }}
            />
            <label htmlFor="confirmationCheck">はい、問題ありません。</label>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>戻る</Button>
          <Button
            onClick={() => {
              handleSubmitComment();
              setConfirmOpen(false);
              setConfirmationChecked(false); // 次のコメント用にリセット
            }}
            disabled={!confirmationChecked}
            variant="contained"
            color="primary"
          >
            コメントを送信する
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openInfoDialog}
        onClose={() => setOpenInfoDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>DDP設定のポイント</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" fontWeight="bold" mt={2}>
            🔷 DDPの目的と基本概念
          </Typography>
          <Typography paragraph>
            DDPとは：自分が「どうなりたいか（なりたい姿）」を明確にするための考え方。手段や通過点ではなく、願望のコアを言語化する。
            <br />
            <br />
            "したい"ではなく"なりたい"を考える：例）「宝くじを当てたい」は“手段”、「経済的に安心した暮らしをしたい」が“なりたい”。
            <br />
            <br />
            最終目的は“ありたい”だが、DDPでは“なりたい”にフォーカスする。
          </Typography>

          <Typography variant="subtitle1" fontWeight="bold">
            🔷 DDPを考える上での3つの視点
          </Typography>
          <Typography paragraph>
            Definition（定義）：願いを明確に、具体的にすること。例：「歌手になりたい」ではなく「私が書いた曲で多くの人を感動させたい」。
            <br />
            Direction（方向）：その願いに向けて今後どのように進むかの指針を持つこと。
            <br />
            Purpose（目的）：その願いの本質的な理由。「それをすることで、どう感じたいのか」。
          </Typography>

          <Typography variant="subtitle1" fontWeight="bold">
            🔷 DDPを作るときの重要なポイント
          </Typography>
          <Typography paragraph>
            自己中心的であること：「他人と比較した金持ち」ではなく「自分が心地よく感じられる暮らし」など、自分基準で考える。
            <br />
            時間性を持つこと：「老後が安心したい」など未来全体ではなく、「半年後にどうなっていたいか」など、期間を定める。
            <br />
            手段と目的を混同しないこと：例）「武道館で歌いたい」は他人依存の手段、「自分が納得できる曲を作りたい」が本来の目的。
            <br />
            積み上げ方式で考える：現実的なステップを重ねて最終ゴールに近づくようにする。
          </Typography>

          <Typography variant="subtitle1" fontWeight="bold">
            🔷 願いを叶える鍵は「信じきれるか」
          </Typography>
          <Typography paragraph>
            願いは「信じきれたら」叶うという前提がある。
            <br />
            自分が“思える”ことは、すでにその世界が存在している証拠（量子力学的観点）。
            <br />
            DDPは、「ただの夢」ではなく、「自分が信じられる願い」としての“なりたい姿”を言語化することで、より現実的にその方向へと動いていくためのツールです。
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenInfoDialog(false)}>閉じる</Button>
        </DialogActions>
      </Dialog>

      {/* 添削連絡 */}
      <Dialog
        open={contactOpen}
        onClose={() => {
          setContactOpen(false);
          setContactTarget(null);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>添削連絡</DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          {contactTarget && (
            <>
              {/* 🌟 相手のDDPカード風 */}
              <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  borderRadius: 3,
                  boxShadow: 1,
                  backgroundColor: "#fdfdfd",
                  mb: 3,
                }}
              >
                <Avatar
                  src={contactTarget.avatar}
                  alt="avatar"
                  sx={{ width: 56, height: 56, mr: 2 }}
                />
                <div>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {contactTarget.name} さんのDDP
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 0.5,
                      backgroundColor: "#f9f9f9",
                      borderRadius: 2,
                      padding: "0.5rem 1rem",
                      fontStyle: "italic",
                    }}
                  >
                    “{contactTarget.ddp}”
                  </Typography>
                </div>
              </Card>
              {/* 💬 自分のコメント */}
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                gutterBottom
                sx={{ mt: 1 }}
              >
                あなたのコメント
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  backgroundColor: "#e8f5e9",
                  borderLeft: "4px solid #4caf50",
                  padding: "0.75rem 1rem",
                  borderRadius: 2,
                  whiteSpace: "pre-wrap",
                  mb: 3,
                }}
              >
                {contactTarget.comment}
              </Typography>
              {/* ✉️ 注意文 */}
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                「送信」ボタンを押すと、ご使用のメールソフトが起動します。
              </Typography>
              <DialogActions>
                <Button
                  onClick={() => {
                    setContactOpen(false);
                    setContactTarget(null);
                  }}
                >
                  閉じる
                </Button>
                {/* ✉️ メーラー起動ボタン */}
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!contactTarget?.mail}
                  component="a"
                  href={mailtoLink}
                >
                  メールで連絡する
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => setMailConfirmOpen(true)}
                  disabled={contactTarget?.mailedBy === currentUser?.uid}
                >
                  ✅ メール送信済にする
                </Button>
              </DialogActions>
              <Typography variant="caption" sx={{ mt: 1 }}>
                ※クリックしてもメールが起動しない場合は、手動でコピー＆送信してください
              </Typography>
              {/* <TextField
                fullWidth
                multiline
                minRows={10}
                value={mailBody}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => {
                        navigator.clipboard.writeText(mailBody);
                        alert("メール本文をコピーしました📋");
                      }}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  ),
                }}
                sx={{ marginTop: 2 }}
              /> */}
              <MailPreviewBox
                mailBody={mailBody}
                recipientMail={contactTarget?.mail}
              />
              {/* <Button
                variant="outlined"
                onClick={() => {
                  const text = `宛先: ${
                    contactTarget?.mail
                  }\n\n件名: マスターマインド夢叶アドバイス\n\n${decodeURIComponent(
                    mailBody
                  ).replace(/%0D%0A/g, "\n")}`;
                  copyToClipboard(text);
                }}
              >
                📋 メール内容をコピーする
              </Button> */}
            </>
          )}
        </DialogContent>
      </Dialog>
      <Dialog open={mailConfirmOpen} onClose={() => setMailConfirmOpen(false)}>
        <DialogTitle>メール送信済にしますか？</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            「メールで連絡する」ボタンを押して、実際にメールを送った後にチェックを入れてください。
          </Typography>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              id="mailConfirmCheck"
              checked={mailConfirmChecked}
              onChange={(e) => setMailConfirmChecked(e.target.checked)}
              style={{ marginRight: 8 }}
            />
            <label htmlFor="mailConfirmCheck">
              はい、メールを実際に送信したことを確認しました
            </label>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setMailConfirmOpen(false);
              setMailConfirmChecked(false);
            }}
          >
            キャンセル
          </Button>
          <Button
            onClick={async () => {
              if (!currentUser || !contactTarget) return;
              try {
                await updateDoc(doc(db, "ReiNoInori", contactTarget.id), {
                  mailedBy: currentUser.uid,
                });
                alert("メール送信済として登録しました！📩");
                setMailConfirmOpen(false);
                setMailConfirmChecked(false);
                setContactOpen(false);
                setContactTarget(null);
              } catch (err) {
                alert("保存に失敗しました。もう一度お試しください。");
              }
            }}
            disabled={!mailConfirmChecked}
            variant="contained"
            color="primary"
          >
            メール送信済に登録する
          </Button>
        </DialogActions>
      </Dialog>

      {/* 🌟 応募用ダイアログ */}
      <Dialog
        open={applyOpen}
        onClose={() => {
          setApplyOpen(false);
          setApplyComment("");
          setApplyApproach("");
          setApplyTarget(null);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>神鍋DDPブース 応募フォーム</DialogTitle>

        <DialogContent dividers>
          {applyTarget && (
            <>
              {/* 対象 DDP のプレビュー */}
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                対象 DDP
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mb: 3,
                  whiteSpace: "pre-wrap",
                  backgroundColor: "#f9f9f9",
                  borderLeft: "4px solid #90caf9",
                  borderRadius: 1,
                  p: 1,
                  fontStyle: "italic",
                }}
              >
                {applyTarget.ddp}
              </Typography>

              {/* ▼ ここを追加 ─ あなたのコメント */}
              {applyTarget.comment && (
                <>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ mt: 1 }}
                  >
                    あなたのコメント
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 3,
                      whiteSpace: "pre-wrap",
                      backgroundColor: "#e8f5e9",
                      borderLeft: "4px solid #4caf50",
                      borderRadius: 1,
                      p: 1,
                      fontStyle: "italic",
                    }}
                  >
                    {applyTarget.comment}
                  </Typography>
                </>
              )}
            </>
          )}

          {/* ▼ フォーム入力欄 */}
          <TextField
            label="DDPコメントで意識したこと"
            placeholder="例：否定形があったので、ポジティブに言い換えるアドバイスを記入した"
            value={applyComment}
            onChange={(e) => setApplyComment(e.target.value)}
            multiline
            minRows={3}
            fullWidth
            sx={{ mb: 3 }}
          />

          <TextField
            label="神鍋DDPブース対話で大切にしたいこと"
            placeholder="自由記述"
            value={applyApproach}
            onChange={(e) => setApplyApproach(e.target.value)}
            multiline
            minRows={3}
            fullWidth
          />

          <Typography
            variant="body2"
            sx={{ mt: 2 }}
            color="error.main"
            fontWeight="bold"
          >
            ※この DDP を神鍋ブースに応募すると、他の DDP には応募できません。
            <br />
            取消は <strong>2025年5月10日&nbsp;23:59</strong> まで可能です。
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setApplyOpen(false);
              setApplyComment("");
              setApplyApproach("");
              setApplyTarget(null);
            }}
          >
            キャンセル
          </Button>
          <Button
            variant="contained"
            disabled={!applyComment.trim() || !applyApproach.trim()}
            onClick={handleSubmit}
          >
            応募する
          </Button>{" "}
        </DialogActions>
      </Dialog>

      <Dialog open={confirmEditOpen} onClose={() => setConfirmEditOpen(false)}>
        <DialogTitle>応募内容を更新しますか？</DialogTitle>
        <DialogContent>
          すでに応募済みの DDP です。内容を上書きしてよろしいですか？
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmEditOpen(false)}>キャンセル</Button>
          <Button
            variant="contained"
            onClick={async () => {
              /* ---- ここで updateDoc 実行 ---- */
              const q = query(
                collection(db, "KannabeDDP"),
                where("ddpId", "==", applyTarget.id),
                where("applicantUid", "==", currentUser.uid)
              );
              const snap = await getDocs(q);
              if (!snap.empty) {
                await updateDoc(snap.docs[0].ref, {
                  commentPoint: applyComment.trim(),
                  approach: applyApproach.trim(),
                  updatedAt: serverTimestamp(),
                });
                /* state 更新は同じ */
                setMembers((prev) =>
                  prev.map((m) =>
                    m.id === applyTarget.id
                      ? {
                          ...m,
                          commentPoint: applyComment.trim(),
                          approach: applyApproach.trim(),
                        }
                      : m
                  )
                );
              }
              alert("応募内容を更新しました！✏️");
              setConfirmEditOpen(false);
              handleDialogClose();
            }}
          >
            更新する
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ReviewGroupMemberList;
